<template>
  <div class="w-full h-full flex flex-col items-center justify-center p-8">
    <div
      class="w-2/3 max-w-sm -mt-24 pointer-events-none lottieContainer min-h-24"
    >
      <LottieComponent :src="$constants.NOTIFICATION.LOTTIES.EMPTY" loop />
    </div>
    <div class="py-2"></div>
    <div class="text-center text-2xl font-bold">Aucune notification</div>
    <div class="py-1"></div>
    <div class="text-center text-lg">
      Aucune notification disponible pour le moment
    </div>
  </div>
</template>
